import _ from 'lodash';
import axios from 'axios';
import { SDLUtil, StringUtil } from '@/utils';

export default {
  async isUserSignup() {
    const user = localStorage.getItem('user');
    if (user === null || user === undefined || user === '') return false;
    const userInfo = JSON.parse(user);
    let isUserSignup = true;
    await axios
      .get(`${SDLUtil.API_URL}/user-etc-info/etc-info?${StringUtil.queryStringfy({ userId: userInfo.userId })}`)
      .then(({ data }) => {
        if (data.privacyPolicy === '0' || _.isEmpty(data.divisionCode) || data.activeFlag === '0') {
          isUserSignup = false;
        }
      });
    return isUserSignup;
  },
};



// WEBPACK FOOTER //
// ./src/service/signupService.js